/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Checking_RatesInputs */

const en_orders_checking_rates = /** @type {(inputs: Orders_Checking_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking Rates...`)
};

const es_orders_checking_rates = /** @type {(inputs: Orders_Checking_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisando tarifas...`)
};

/**
* | output |
* | --- |
* | "Checking Rates..." |
*
* @param {Orders_Checking_RatesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_checking_rates = /** @type {((inputs?: Orders_Checking_RatesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Checking_RatesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_checking_rates(inputs)
	return es_orders_checking_rates(inputs)
});